export const addTickets = async (
  competitionId: number,
  prizeContentNodeId: number,
  quantityToAdd: number,
  addToCartMethodId: number
) => {
  return fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/cart/addtickets?competitionId=${competitionId}&prizeContentNodeId=${prizeContentNodeId}&quantityToAdd=${quantityToAdd}&answerId=undefined&addToCartMethodId=${addToCartMethodId}`,
    {
      method: "POST",
    }
  );
};

export const getPrizeStats = async () => 
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/UspStats/GetPrizeStatsBanner`, { method: "GET" });

export const getCurrencies = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/CurrencySelector/GetCurrencies`);

export const getCompetitionCTAMacroParameters = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/botbdynamiccontent/GetCompetitionCTAMacroParameters`);

export const getUmbracoGrid = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/botbdynamiccontent/GetGrid?pathName=${location.pathname}`);

export const subscriptionTicketsEnterNow = async (competitionId: number, prizeId: number, quantityToAdd: number) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/StripeSubscriptionServerSide/playInstantWinTickets?competitionId=${competitionId}&prizeId=${prizeId}&quantityToAdd=${quantityToAdd}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        competitionId: competitionId,
        prizeId: prizeId,
        quantityToAdd: quantityToAdd,
      }),
    }
  );

export const getBotbPrizeStraplineTexts = (abortController: AbortController) =>
  fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/GetPrizeStraplineTexts`, {
    signal: abortController.signal,
  });
